// extracted by mini-css-extract-plugin
export default {"card":"Card_card__BsU8p","security":"Card_security__rEMmr","sanitary":"Card_sanitary__yU92O","vehicule":"Card_vehicule__N5UqN","disabled":"Card_disabled__LHDV9"};